export default __webpack_public_path__ + "static/media/agreement-background.2f0e3a00.svg";